import { http } from '../../config/axios'
import { User } from '../../interface/User'

export default function getUser(): Promise<User> {
  return http
    .get('api/user')
    .then((res) => {
      return res.data as User
    })
    .catch((error) => {
      console.error('Erro getUser', error)
      throw Error(error.response.data)
    })
}
